<template>
  <b-modal
    :id="modalId"
    v-model="show"
    centered
    hide-footer
    close-disable
    hide-header-close
    hide-header
    body-class="text-center p-0"
    lazy
  >
    <div class="card" :class="size ? 'p-5' : 'p-2'">
      <div class="mb-2">{{ $t('settings.conformationQuestion') }}</div>
      <div class="d-flex justify-content-between align-items-center mt-4">
        <b-button variant="transparent" :size="buttonSize" @click="show = false">
          {{ $t('button.cancel.label') }}
        </b-button>
        <b-button variant="danger" :size="buttonSize" @click="onOk()">
          {{ $t('button.delete.label') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { vueWindowSizeMixin } from 'vue-window-size';

export default {
  name: 'DeleteConfirmationModal',
  mixins: [vueWindowSizeMixin],
  props: {
    title: String,
    modalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    size() {
      return this.windowWidth > 775;
    },
    buttonSize() {
      return this.size ? 'lg' : 'md';
    },
  },
  methods: {
    onOk() {
      this.$emit('ok');
      this.show = false;
    },
  },
};
</script>

<style></style>
